import { Component, OnInit, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormBuilder, FormGroup, FormsModule, Validators } from "@angular/forms";
import { UsersService } from "../../../../core/services/users.service";
import { RoleService } from "../../../../core/services/role.service";
import { LoaderService } from "../../../../core/shared/services/loader.service";
import { ConfigurationService } from "../../../../core/services/configuration.service";
import { UserType } from "../../../../core/models/user-type.model";
import { ContentObserver } from '@angular/cdk/observers';
import { ActivatedRoute } from "@angular/router";
import { USER_TYPES } from "../../../../core/shared/constants";
import { User } from "../../../../core/models/user.interface";
import { BaseComponent } from "../../../../core/shared/base.component";
import Swal from "sweetalert2";
import { NgxSpinnerService } from "ngx-spinner";
import { NgSelectComponent } from '@ng-select/ng-select';


@Component({
  selector: "app-users-management",
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule,
    NgSelectComponent
  ],
  templateUrl: "./users-management.component.html",
  styleUrls: ["./users-management.component.scss"],
})
export class UsersManagementComponent extends BaseComponent implements OnInit {
  usersBase: any[] = [];
  users: any[] = [];
  userTypes: UserType[] = [];
  loading = false;
  selectedUser: any = null;
  Math = Math;
  // Agregar la función Number para usar en el template
  Number = Number;

  selectedUserType: number | null = null;
  selectedCoachType: number | null = null;
  selectedExpertCategory: number | null = null;
  // Guardar la información de suscripción original
  originalSubscriptionType: any = null;
  originalSubscriptionStatus: any = null;

  userTypesEnum = USER_TYPES;

  // Propiedades de paginación
  currentPage = 1;
  pageSize = 10;
  totalUsers = 0;
  totalPages = 0;

  showModalForm = false; // Controla la visibilidad del modal
  editMode: boolean = false; // Indica si estamos en modo edición
  usuarioFormGroup!: FormGroup;
  estados: any[] = [];
  selectedEstado: string = '';
  mentores: any[] = []; // Lista de mentores para el select
  selectedUserId: string = ''; // ID del usuario seleccionado para edición
  source: string = ''; // Fuente de los usuarios

  private userService = inject(UsersService);
  private roleService = inject(RoleService);
  private configService = inject(ConfigurationService);
  private loader = inject(LoaderService);
  private route = inject(ActivatedRoute);
  private spinner = inject(NgxSpinnerService);
  private formBuilder = inject(FormBuilder); // FormBuilder para crear formularios reactivos

  activeTab: any = 'all'; // Tab activo por defecto
  searchTerm: any;
  subscriptionTypes: any[] = [];
  coachTypes: any[] = [];
  expertCategories: any[] = [];
  selectsuscriptionType: any = '0'; // Valor por defecto para el tipo de suscripción
  totalTodosUsuarios: number = 0; // Total de usuarios
  userTypeId = USER_TYPES.Customer.id;
  pageTitle = "Administración de Usuarios";

  constructor() {
    super();
  }

  get currentWeek(): { week: number; day: number } | null {
    const dateValue = this.usuarioFormGroup?.get('FECHAINGRESO')?.value;
    if (!dateValue) {
      return null;
    }

    const parseDate = (value: string): Date => {
      const [year, month, day] = value.split('-').map(Number);
      return new Date(year, (month ?? 1) - 1, day ?? 1);
    };

    const selectedDate = parseDate(dateValue);

    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const diffInMs = today.getTime() - selectedDate.getTime();
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInDays < 0) {
      return null;
    }

    const week = Math.floor(diffInDays / 7) + 1;
    const day = (diffInDays % 7) + 1;

    return {
      week,
      day
    };
  }

  ngOnInit() {

    this.route.data.subscribe(data => {
      this.userTypeId = data['userTypeId'];
      this.pageTitle = data['pageTitle'];

      // this.loadData(); // con paginación
      // this.loadUserTypes()
      this.loadTypes(); // Cargar tipos 
      this.loadUsers(); // sin paginación
      this.loadUserStatus(); // Cargar estados de usuario
      this.loadUserSubscriptions(); // Cargar tipos de suscripción
      this.loadMentors(); // Cargar mentores para el select
    });

    this.crearFormulario();
  }

  crearFormulario(): void {
    this.usuarioFormGroup = this.formBuilder.group({
      FULLNAME: ['', Validators.required],
      EMAIL: ['', [Validators.required, Validators.email]],
      CODETELEFONO: ['51'],
      TELEFONO: [''],
      FECHAINGRESO: [new Date().toISOString().substring(0, 10), Validators.required],
      ESTADO: ['1', Validators.required],
      SUBSCRIPCION: ['1', Validators.required],
      MENTORASIGNADO: [''],
    });
  }
  // getter para un fácil acceso a los campos de formulario
  get frmUsuario(): any { return this.usuarioFormGroup.controls; } // get de los controles

  loadUsers() {
    this.loading = true;
    this.loader.show();

    this.userService.find(this.userTypeId, '').subscribe({
      next: (response: any) => {
        this.usersBase = response.data;
        this.usersBase = this.usersBase.map((user: any) => {
          // Convertir explícitamente los ids de suscripción a números
          // if (user.type && user.type.suscriptionType && user.type.suscriptionType.id) {
          //   user.type.suscriptionType.id = Number(user.type.suscriptionType.id);
          // }

          // Agregar propiedad para el ngModel del select
          user.selectedSubscriptionId = user.type?.suscriptionType?.id?.toString() || '0';
          user.selectedCoachTypeId = user.type?.coachType?.id || 0;
          user.selectedExpertCategoryId = user.type?.expertCategory?.id || 0;

          if (user.type?.expertCategory) {
            console.log('user.type?.expertCategory', user.type?.expertCategory);
          }

          return user;
        });

        this.totalTodosUsuarios = this.usersBase.length; // Total de usuarios sin paginación
        this.users = this.usersBase;
        this.loading = false;
        this.loader.hide();
      },
      error: (error) => {
        console.error('Error cargando usuarios:', error);
        this.loading = false;
        this.loader.hide();
      }
    });
  }

  // Método para cargar usuarios con paginación
  loadData() {
    this.loading = true;
    this.loader.show();

    this.userService.getAllUsersWithSubscriptionsPaginated(this.currentPage, this.pageSize).subscribe({
      next: (response: any) => {
        console.log('response.data:', response.data);
        // Convertir explícitamente los ids de tipo a números
        this.users = response.data.users.map((user: any) => {
          if (user.type && user.type.id) {
            user.type.id = Number(user.type.id);
          }
          return user;
        });

        this.totalUsers = response.data.total;
        this.totalPages = response.data.totalPages;
        this.loading = false;
        this.loader.hide();
      },
      error: (error) => {
        console.error('Error cargando usuarios:', error);
        this.loading = false;
        this.loader.hide();
      }
    });

    // Cargar tipos de usuario si aún no se han cargado
    if (this.userTypes.length === 0) {
      this.loadUserTypes();
    }
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.loadData();
    }
  }

  previousPage() {
    this.goToPage(this.currentPage - 1);
  }

  nextPage() {
    this.goToPage(this.currentPage + 1);
  }

  getPagesToShow(): number[] {
    const pages: number[] = [];
    const totalPagesToShow = 5; // Mostrar hasta 5 botones de página

    let startPage = Math.max(1, this.currentPage - Math.floor(totalPagesToShow / 2));
    let endPage = Math.min(this.totalPages, startPage + totalPagesToShow - 1);

    // Ajustar si estamos al final
    if (endPage - startPage + 1 < totalPagesToShow && startPage > 1) {
      startPage = Math.max(1, endPage - totalPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  }

  // Helper para usar Math.min en el template
  get mathMin(): any {
    return Math;
  }

  // fin paginacion

  // editUser(user: any) {
  //   this.selectedUser = { ...user };

  //   // Limpiar la información de suscripción original antes de comenzar
  //   this.originalSubscriptionType = null;
  //   this.originalSubscriptionStatus = null;

  //   // Si el usuario tiene un tipo, seleccionarlo y convertirlo a número
  //   if (this.selectedUser.type && this.selectedUser.type.id) {
  //     this.selectedUserType = Number(this.selectedUser.type.id);

  //     // Guardar la información de suscripción original si es Cliente
  //     if (this.selectedUserType === 1) {
  //       this.originalSubscriptionType = this.selectedUser.type.suscriptionType ?
  //         { ...this.selectedUser.type.suscriptionType } : null;
  //       this.originalSubscriptionStatus = this.selectedUser.type.suscriptionStatus ?
  //         { ...this.selectedUser.type.suscriptionStatus } : null;
  //     }
  //   } else {
  //     this.selectedUserType = null;
  //   }
  // }

  // isUserTypeSelected(typeId: number): boolean {
  //   if (!this.selectedUser || !this.selectedUser.type) return false;
  //   return Number(this.selectedUser.type.id) === typeId;
  // }

  // updateUserType(typeId: number) {
  //   const oldTypeId = this.selectedUserType;
  //   this.selectedUserType = typeId;

  //   const selectedType = this.userTypes.find(t => t.id === typeId);

  //   if (selectedType && this.selectedUser) {
  //     // Si cambia de otro tipo a Cliente y previamente fue Cliente, restaurar la info de suscripción
  //     if (typeId === 1 && oldTypeId !== 1 && this.originalSubscriptionType) {
  //       this.selectedUser.type = {
  //         id: selectedType.id,
  //         name: selectedType.name,
  //         suscriptionType: this.originalSubscriptionType,
  //         suscriptionStatus: this.originalSubscriptionStatus
  //       };
  //     } else {
  //       // Si cambia a un tipo que no es Cliente, o es primera vez como Cliente
  //       this.selectedUser.type = {
  //         id: selectedType.id,
  //         name: selectedType.name,
  //       };

  //       // Eliminar suscripciones solo si no es Cliente
  //       if (typeId !== 1) {
  //         delete this.selectedUser.type.suscriptionType;
  //         delete this.selectedUser.type.suscriptionStatus;
  //       } else if (typeId === 1 && !this.originalSubscriptionType) {
  //         this.selectedUser.type.suscriptionType = { id: "1", name: "Freemiun" };
  //         this.selectedUser.type.suscriptionStatus = { id: "1", name: "Vigente" };
  //       }
  //     }
  //   }

  //   console.log('this.selectedUser.type', this.selectedUser.type);
  // }

  updateCoachType(user: any, event: any) {
    const selectedType = this.coachTypes.find(t => t.id === Number(event.target.value));

    if (selectedType && user) {


      Swal.fire({
        html: `Va ha actualizar el tipo de coach de <strong>${user.name}</strong> a <strong>${selectedType.name}</strong>. ¿Desea continuar ?`,
        title: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.spinner.show();
          this.userService.updateCoachType(user._id, Number(event.target.value)).subscribe({
            next: (res) => {
              this.spinner.hide();
              user.type.coachType = selectedType;
            },
            error: () => {
              this.spinner.show();
            }
          });
        } else {
          user.selectedCoachTypeId = user.type?.coachType?.id || 0;
        }
      });

    }
  }

  updateExpertCategory(user: any, event: any) {
    const selectedCategory = this.expertCategories.find(t => t.id === Number(event.target.value));
    if (selectedCategory && user) {


      Swal.fire({
        html: `Va ha actualizar la categoría de experto <strong>${user.name}</strong> a <strong>${selectedCategory.name}</strong>. ¿Desea continuar ?`,
        title: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.spinner.show();
          this.userService.updateExperCategory(user._id, Number(event.target.value)).subscribe({
            next: (res) => {
              this.spinner.hide();
              user.type.expertCategory = selectedCategory;
            },
            error: () => {
              this.spinner.hide();
            }
          });
        } else {
          user.selectedExpertCategoryId = user.type?.expertCategory?.id || 0;
        }
      });


    }

  }

  // saveUserChanges() {
  //   if (!this.selectedUser) return;

  //   this.loader.show();

  //   if (this.selectedUserType === null) {
  //     console.error("No se ha seleccionado ningún tipo de usuario");
  //     this.loader.hide();
  //     return;
  //   }

  //   const userId = this.selectedUser._id;
  //   const statusId = this.selectedUser.status.id;
  //   // Asegurar que typeId sea un número
  //   const typeId = Number(this.selectedUserType);

  //   this.userService.updateUserType(userId, typeId).subscribe({
  //     next: (typeUpdateResponse) => {
  //       this.userService.updateStatus(userId, statusId).subscribe({
  //         next: (statusUpdateResponse) => {
  //           this.loadData();
  //           this.selectedUser = null;
  //           this.selectedUserType = null;
  //           this.originalSubscriptionType = null;
  //           this.originalSubscriptionStatus = null;
  //         },
  //         error: (statusError) => {
  //           console.error("Error actualizando estado:", statusError);
  //           this.loader.hide();
  //         },
  //         complete: () => {
  //           this.loader.hide();
  //         }
  //       });
  //     },
  //     error: (typeError) => {
  //       console.error("Error actualizando tipo de usuario:", typeError);
  //       this.loader.hide();
  //     },
  //   });
  // }

  // cancelEdit() {
  //   this.selectedUser = null;
  //   this.selectedUserType = null;
  // }

  // getPlanName(planId: string): string {
  //   switch (planId) {
  //     case "Executive":
  //       return "Executive";
  //     case "Profesional":
  //       return "Profesional";
  //     case "Fremium":
  //       return "Fremium";
  //     default:
  //       return "Desconocido";
  //   }
  // }



  // Cargar tipos de usuario
  loadUserTypes() {
    this.configService.getUserTypes().subscribe({
      next: (response: any) => {
        // Convertir explícitamente los ids a números
        this.userTypes = response.data.map((type: any) => ({
          ...type,
          id: Number(type.id)
        }));
        console.log('this.userTypes:', this.userTypes);
      },
      error: (error) => {
        console.error('Error cargando tipos de usuario:', error);
      }
    });
  }

  loadTypes() {
    // this.configService.getSubscriptionTypes().subscribe({
    //   next: (response: any) => {
    //     // Convertir explícitamente los ids a números para consistencia
    //     this.subscriptionTypes = response.data.map((type: any) => ({
    //       ...type,
    //       id: Number(type.id)
    //     }));
    //     // this.subscriptionTypes = response.data;
    //     console.log('Tipos de suscripción:', this.subscriptionTypes);
    //   },
    //   error: (error) => {
    //     console.error('Error cargando tipos de suscripción:', error);
    //   }
    // });
    this.configService.getCoachTypes().subscribe({
      next: (response: any) => {
        // Convertir explícitamente los ids a números para consistencia
        this.coachTypes = response.data.map((type: any) => ({
          ...type,
          id: Number(type.id)
        }));
        // this.subscriptionTypes = response.data;
        console.log('Tipos de coach:', this.coachTypes);
      },
      error: (error) => {
        console.error('Error cargando tipos de suscripción:', error);
      }
    });
    this.configService.getExpertCategories().subscribe({
      next: (response: any) => {
        // Convertir explícitamente los ids a números para consistencia
        this.expertCategories = response.data.map((type: any) => ({
          ...type,
          id: Number(type.id)
        }));
        // this.subscriptionTypes = response.data;
        console.log('Categoría expertos:', this.expertCategories);
      },
      error: (error) => {
        console.error('Error cargando tipos de suscripción:', error);
      }
    });
  }

  changeUserType(userTypeId: number) {
    this.users = this.usersBase.filter(x => x.type.id == userTypeId);
  }

  changeAll() {
    this.activeTab = 'all';
    this.loadUsers(); // Recargar usuarios para asegurarse de que se muestren todos
    this.searchTerm = ''; // Limpiar el término de búsqueda
  }

  changeNew() {
    this.activeTab = 'new';
    this.searchTerm = ''; // Limpiar el término de búsqueda
    // filtrar usuarios por createdAt
    this.users = this.users.filter(user => {
      const createdAt = new Date(user.createdAt);
      const today = new Date();
      const diffTime = Math.abs(today.getTime() - createdAt.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays <= 1; // Mostrar usuarios creados en los últimos 1 días
    });

  }

  newAccount() {
    this.showModalForm = true; // Mostrar el modal para crear una nueva cuenta
    this.editMode = false; // Desactivar el modo edición
    this.source = 'local'; // Asignar la fuente de la nueva cuenta
    // Implementar la lógica para crear una nueva cuenta
    // Por ejemplo, podrías abrir un formulario para ingresar los datos de la nueva cuenta
    console.log("Crear nueva cuenta");
    this.usuarioFormGroup.patchValue({
      FULLNAME: '',
      EMAIL: '',
      TELEFONO: '',
      FECHAINGRESO: new Date().toISOString().substring(0, 10),
    });
    // this.usuarioFormGroup.markAsPristine();
    // this.usuarioFormGroup.markAsUntouched();
  }


  updateUserSubscription(user: any, event: any) {
    const newSubscriptionId = event.target.value;
    const subscriptionId = Number(newSubscriptionId);
    const selectedSubscription = this.subscriptionTypes.find(sub => Number(sub.id) === subscriptionId);

    Swal.fire({
      html: `Va ha actualizar la suscripción del usuario <strong>${user.name} </strong>  a <strong>${selectedSubscription.name}</strong>. ¿Desea continuar ?`,
      title: '',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        // Actualizar la propiedad del ngModel
        user.selectedSubscriptionId = newSubscriptionId;

        if (subscriptionId === 0) {
          if (user.type) {
            user.type.suscriptionType = null;
          }
        } else {

          if (selectedSubscription) {
            if (!user.type) {
              user.type = {};
            }
            user.type.suscriptionType = { ...selectedSubscription };
          }
        }

        this.loader.show();
        this.userService.updateSubscriptionType(user._id, newSubscriptionId).subscribe({
          next: (res: any) => {
            console.log('updateSubscriptionType-res', res)
            this.loader.hide();
          },
          error: () => {
            this.loader.hide();
          }
        });
      } else {
        user.selectedSubscriptionId = user.type?.suscriptionType?.id?.toString() || '0';
      }
    });


  }

  // busqueda usuario
  searchUsers() {
    const term = this.searchTerm.toLowerCase().trim();

    if (!term || term.trim() === '') {
      // Si la búsqueda está vacía, mostrar todos los usuarios
      this.loadUsers();
      return;
    }
    // Filtrar usuarios por nombre
    this.users = this.users.filter(user => {
      const userName = user.name ? user.name.toLowerCase() : '';
      return userName.includes(term);
    }
    );
    console.log('Usuarios filtrados:', this.users);
  }


  OnUpdated(event: any) {
    console.log('event', event);

  }


  closeModalForm() {
    this.showModalForm = false; // Ocultar el modal
  }

  guardarUsuario() {
    if (this.usuarioFormGroup.invalid) {
      console.error("Formulario inválido");
      return;
    }

    const textSubscription = this.subscriptionTypes.find(sub => sub.id === this.frmUsuario.SUBSCRIPCION.value)?.name;
    const textEstado = this.estados.find(estado => estado.id === this.frmUsuario.ESTADO.value)?.name;
    const textMentor = this.mentores.find(mentor => mentor._id === this.frmUsuario.MENTORASIGNADO.value)?.name;

    // 1. Usuario selecciona en el input: 30 de Junio 2025
    const fechaInput = this.frmUsuario.FECHAINGRESO.value; // "2025-06-30"
    console.log('fechaInput', fechaInput)

    // Explicacion:
    // ❌ PROBLEMA con medianoche UTC:
    // new Date("2025-06-30T00:00:00.000Z")
    // En Perú (UTC-5): Se muestra como "2025-06-29 19:00" (día anterior)

    // ✅ SOLUCIÓN con mediodía UTC:
    // new Date("2025-06-30T12:00:00.000Z")
    // En Perú (UTC-5): Se muestra como "2025-06-30 07:00" (mismo día)

    //Ejemplo:
    const fechaUTC = new Date(fechaInput + 'T00:00:00Z'); // UTC ISO para guardar en MongoDB
    console.log("fechaUTC.toISOString:", fechaUTC.toISOString());
    // Resultado: "2025-06-29T00:00:00.000Z" ❌
    // En Perú (UTC-5): Se muestra como "2025-06-29 19:00" (día anterior)

    // 2. Agregar tiempo específico para evitar cambios de zona horaria
    // Convierte: "2025-06-30" → "2025-06-30T12:00:00.000Z"
    const fechaCorrecta = new Date(fechaInput + 'T12:00:00.000Z'); // Mediodía UTC
    console.log('fechaCorrecta.toISOString()', fechaCorrecta.toISOString());
    // Resultado: "2025-06-30T12:00:00.000Z"  ✅

    // 3. MongoDB guarda: 2025-06-30 (fecha correcta)    

    const fullName: string = this.frmUsuario.FULLNAME.value;
    const usuarioData = {
      name: fullName,
      firstName: fullName,
      lastName: '',
      email: this.frmUsuario.EMAIL.value,
      source: this.source, // Asignar la fuente del usuario
      phone: this.frmUsuario.TELEFONO.value,
      codePhone: this.frmUsuario.CODETELEFONO.value,
      // createdAt: this.frmUsuario.FECHAINGRESO.value,
      createdAt: fechaCorrecta.toISOString(),
      // photo: null,
      type: {
        ...USER_TYPES.Customer,
        suscriptionType: {
          id: this.frmUsuario.SUBSCRIPCION.value,
          name: textSubscription,
        },
        suscriptionStatus: {
          id: '1',
          name: 'Vigente',
        },
      },
      status: {
        id: Number(this.frmUsuario.ESTADO.value),
        name: textEstado,
      },
      coachAssigned: {
        id: this.frmUsuario.MENTORASIGNADO.value,
        name: textMentor
      }
    };


    // Aquí puedes llamar al servicio para guardar el usuario
    console.log("Datos del usuario a guardar:", usuarioData);

    if (this.editMode) {
      // Si estamos en modo edición, actualizar el usuario existente
      // console.log('this.selectedUserId', this.selectedUserId)
      this.userService.updateUser(this.selectedUserId, usuarioData).subscribe({
        next: (response: any) => {
          console.log('Usuario actualizado:', response.data);
          this.loadUsers(); // Recargar la lista de usuarios después de actualizar
          // Cerrar el modal después de actualizar
          this.closeModalForm();
        },
        error: (error) => {
          console.error('Error actualizando usuario:', error);
        }
      });
    }
    else {
      // Si no estamos en modo edición, crear un nuevo usuario
      // Implementa la lógica para guardar el usuario
      this.userService.createUser(usuarioData).subscribe({
        next: (response: any) => {
          console.log('GUARDADO:', response.data);
          this.loadUsers(); // Recargar la lista de usuarios después de guardar
          // Cerrar el modal después de guardar
          this.closeModalForm();
        },
        error: (error) => {
          console.error('Error:', error);
        }
      });
    }
    // Cerrar el modal después de guardar
    // this.closeModalForm();
  }

  // cargar Estados de usuario
  loadUserStatus() {
    this.configService.getUserStatuses().subscribe({
      next: (response: any) => {
        // Convertir explícitamente los ids a números
        this.estados = response.data
        console.log('Estados cargados:', this.estados);
      },
      error: (error) => {
        console.error('Error cargando estados:', error);
      }
    });
  }

  selectEstado(event: any): void {
    // console.log('event: ', event);
    this.selectedEstado = event.target.options[event.target.options.selectedIndex].text;
    console.log('selectedProyect: ', this.selectedEstado);
    const selectedValue = event.target.value;
    console.log('Estado seleccionado:', selectedValue);
  }

  // cargar las subscripciones de usuario
  loadUserSubscriptions() {
    this.configService.getSubscriptionTypes().subscribe({
      next: (response: any) => {
        this.subscriptionTypes = response.data;
        console.log('Tipos de suscripción:', this.subscriptionTypes);
      },
      error: (error) => {
        console.error('Error cargando tipos de suscripción:', error);
      }
    });
  }

  selectSuscripcion(event: any): void {
    // console.log('event: ', event);
    const selectedValue = event.target.value;
    console.log('Suscripción seleccionada:', selectedValue);
    this.selectsuscriptionType = selectedValue; // Actualizar el valor seleccionado
  }

  // cargar mentores
  loadMentors() {
    this.userService.find(2, '').subscribe({
      next: (response: any) => {
        this.mentores = response.data;
        console.log('Mentores cargados:', this.mentores);
        // Seleccionar el primer mentor por defecto después de cargar los datos
        if (this.mentores.length > 0) {
          this.usuarioFormGroup.patchValue({
            MENTORASIGNADO: this.mentores[0]._id
          });
        }
      },
      error: (error) => {
        console.error('Error cargando mentores:', error);
      }
    });
  }

  selectMentor(event: any): void {
    // console.log('event: ', event);
    const selectedValue = event.target.value;
    console.log('Mentor seleccionado:', selectedValue);
    this.usuarioFormGroup.patchValue({ MENTORASIGNADO: selectedValue }); // Actualizar el valor del formulario
  }

  editarUsuario(usuario: any) {
    this.editMode = true; // Activar el modo edición
    this.showModalForm = true; // Mostrar el modal de edición
    console.log('Editar usuario:', usuario);
    this.selectedUserId = usuario._id; // Guardar el ID del usuario seleccionado
    this.source = usuario.source; // Asignar la fuente del usuario 
    console.log('Fuente del usuario:', this.source);

    const fechaCreacion = new Date(usuario.createdAt);
    const fechaLocal = fechaCreacion.toLocaleDateString('en-CA'); // Formato YYYY-MM-DD
    console.log('fechaLocal', fechaLocal);

    const fullName = usuario.name || [usuario.firstName, usuario.lastName].filter(Boolean).join(' ').trim();
    this.usuarioFormGroup.patchValue({
      FULLNAME: fullName,
      EMAIL: usuario.email,
      TELEFONO: usuario.phone,
      CODETELEFONO: usuario.codePhone || '51', // Asignar código de teléfono por defecto si no existe
      FECHAINGRESO: fechaLocal || new Date().toLocaleDateString('en-CA'),
      ESTADO: usuario.status ? (usuario.status.id).toString() : '2', // Asignar ID de estado o 2 por defecto
      SUBSCRIPCION: usuario.type.suscriptionType ? usuario.type.suscriptionType.id : '1', // Asignar ID de suscripción o '1' por defecto
      MENTORASIGNADO: usuario.coachAssigned ? usuario.coachAssigned.id : '' // Asignar mentor asignado o vacío por defecto
    });
  }

}

